<div class="tabs">
  <div class="tabs-wrapper">
    <ng-container *ngIf="slice.settings">
      <div
        *ngFor="let tab of tabsRange; trackBy: trackByIndex"
        class="tab"
        [class.selected]="currentTab === tab"
        (click)="goToTab(tab)">
        <ng-container *idtLet="slice.settings.general.tabs[tab] as tabContent">
          <!-- eslint-disable @angular-eslint/template/no-call-expression -->
          <img
            *ngIf="tabTypeHasIcon && tabContent.icon"
            [src]="getTabIconSrc(tabContent.icon, currentTab === tab)"
            alt="{{ tabContent.alt }}"
            [attr.width]="tabContent.icon.width"
            [attr.height]="tabContent.icon.height">
          <render-wysiwyg
            *ngIf="tabTypeHasText"
            [html]="tabContent.text ?? tabContent.alt">
          </render-wysiwyg>
          <!-- eslint-enable @angular-eslint/template/no-call-expression -->
        </ng-container>
      </div>
    </ng-container>
  </div>
</div>

<div class="content">
  <ng-container *ngFor="let tab of tabsRange; trackBy: trackByIndex">
    <!-- eslint-disable @angular-eslint/template/no-call-expression -->
    <render-slice-slot
      *ngIf="loadedTabs[tab]"
      data-e2e="render-slice-slot"
      class="slot"
      [class.visible]="currentTab === tab"
      [slice]="slice"
      [slot]="(tab + 1).toString()"
      [ngStyle]="getSlotStyles(slots[tab])">
    </render-slice-slot>
    <!-- eslint-enable @angular-eslint/template/no-call-expression -->
  </ng-container>
</div>

